import { Dimmer, Loader, Message, Table } from 'semantic-ui-react';
import React, { Fragment, FunctionComponent, useMemo } from 'react';
import { useNavigate } from 'react-router';
import ProFullName from 'components/pro-full-name/pro-full-name';
import { PhoneNumber } from 'utils';
import { ListContactItem } from 'generated/api-client';

type ContactsTableProps = {
  loading: boolean;
  contacts?: ListContactItem[];
  orderBy?: {
    column: string;
    direction: 'ascending' | 'descending';
  };
  onSort?: (column: string, direction: string) => void;
};
export const ContactsTableView: FunctionComponent<ContactsTableProps> = ({
  loading,
  contacts,
  orderBy,
  onSort,
}) => {
  const navigate = useNavigate();

  const direction = useMemo(() => {
    switch (orderBy?.direction) {
      case 'ascending':
      case 'descending':
        return orderBy.direction;
      default:
        return 'ascending';
    }
  }, [orderBy?.direction]);

  if (!contacts || contacts?.length === 0) {
    return <Message>Il n&apos;y a pas de résultats</Message>;
  }

  return (
    <>
      <Dimmer.Dimmable>
        <Dimmer inverted verticalAlign="top" active={loading}>
          <Loader style={{ marginTop: '20px' }} inline>
            Chargement...
          </Loader>
        </Dimmer>
        <Table striped celled sortable selectable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell className="not sortable">
                Prénom
              </Table.HeaderCell>
              <Table.HeaderCell
                sorted={
                  orderBy?.column === 'familyName' ? direction : undefined
                }
                onClick={(): void => {
                  if (onSort) {
                    const isCurrentColumn = orderBy?.column === 'familyName';
                    onSort(
                      'familyName',
                      isCurrentColumn && direction === 'ascending'
                        ? 'descending'
                        : 'ascending',
                    );
                  }
                }}
              >
                Nom
              </Table.HeaderCell>
              <Table.HeaderCell className="not sortable">
                Email
              </Table.HeaderCell>
              <Table.HeaderCell className="not sortable">
                Téléphone
              </Table.HeaderCell>
              <Table.HeaderCell className="not sortable">
                Fiches
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {contacts.map((contact) => (
              <Table.Row key={contact.id}>
                <Table.Cell>{contact.givenName}</Table.Cell>
                <Table.Cell>{contact.familyName}</Table.Cell>
                <Table.Cell>{contact.email}</Table.Cell>
                <Table.Cell>
                  {contact.phoneNumber
                    ? PhoneNumber.format(contact.phoneNumber)
                    : null}
                </Table.Cell>
                <Table.Cell>
                  {contact.views?.map((view) => {
                    return (
                      <Fragment
                        key={`pro-person-${contact.id}-pro-view-${view.id}`}
                      >
                        <a
                          onClick={(): void => {
                            navigate(`/pros/update/${view.id}`);
                          }}
                          style={{ cursor: 'pointer' }}
                        >
                          <ProFullName
                            name={view.presentationName}
                            mainCityCode={view.networkName}
                            mainTradeNames={view.mainCategoryNames}
                            status={view.status}
                          />
                        </a>
                        <br />
                      </Fragment>
                    );
                  })}
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </Dimmer.Dimmable>
    </>
  );
};
